import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import { invalidateQueryKeys } from 'utils/invalidateQueryKeys';

export const useAddTurnaroundImplantsToDelivery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.addTurnaroundImplantsToDelivery>) =>
      API.deliveries.addTurnaroundImplantsToDelivery(...args),
    onSuccess: async () => {
      await invalidateQueryKeys({
        queryClient,
        queryKeys: [QueryKeys.Delivery, QueryKeys.Deliveries, QueryKeys.TurnaroundList],
      });
    },
  });
};
